<template>
  <div id="app">
    <!-- <h1>这是一个新创项目</h1> -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
<style lang="less" scoped>
// #app {
//   margin-bottom: 300px;
//   position: relative;
// }
</style>



// WEBPACK FOOTER //
// src/App.vue